import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  updateProfile,
  signOut,
  sendPasswordResetEmail,
  User,
} from "firebase/auth";
import { auth } from "../firebase";
import { getAuthErrorMessage } from "../utils/authErrors";
import { useMutation } from "@tanstack/react-query";
import apiClient, { ApiResponse } from "./apiClient";

export const loginWithEmail = async (email: string, password: string): Promise<User> => {
  try {
    const result = await signInWithEmailAndPassword(auth, email, password);
    return result.user;
  } catch (err: any) {
    throw new Error(getAuthErrorMessage(err.code));
  }
};

export const logOut = async (): Promise<void> => {
  await signOut(auth);
};

export const resetPassword = async (email: string): Promise<void> => {
  try {
    await sendPasswordResetEmail(auth, email);
  } catch (err: any) {
    throw new Error(getAuthErrorMessage(err.code));
  }
};

const forgotPassword = async (email: string): Promise<void> => {
  await apiClient.post<ApiResponse<void>>("/v1/admin/auth/forgot-password", { email });
};

export const useForgotPassword = () =>
  useMutation({ mutationFn: forgotPassword });

const changePassword = async (body: { current_password: string; new_password: string }): Promise<void> => {
  await apiClient.put<ApiResponse<void>>("/v1/admin/auth/password", body);
};

export const useChangePassword = () =>
  useMutation({ mutationFn: changePassword });

export const signUpWithEmail = async (
  email: string,
  password: string,
  firstName: string,
  lastName: string
): Promise<User> => {
  try {
    const result = await createUserWithEmailAndPassword(auth, email, password);
    await updateProfile(result.user, { displayName: `${firstName} ${lastName}` });
    return result.user;
  } catch (err: any) {
    throw new Error(getAuthErrorMessage(err.code));
  }
};
